import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { NotificationManager } from 'react-notifications';
import ToggleButton from '../../../layout/shared/ToggleButton';
import TextTooltip from '../../../tootip/TextTooltip';
import ElectronicSignatureTable from './componets/ElectronicSignatureTable';
import { useElectronicSignatureProcessContext } from './context/ElectronicSignatureProcessContext';
import CredentialsModal, { SignatureInputFile } from './credentialsModal/CredentialsModal';
import { showAlertForDocumentToBeSignedNotAllowed } from '../../../government_book/details_expedient/services/showAlertForDocumentToBeSignedNotAllowed';
import { getIsAValidMaxFileSize } from '../../../../services/assert/getIsAValidMaxFileSize';
import { getFileWithExtensionInLowercase } from '../../../government_book/details_expedient/services/getFileWithExtensionInLowercase';
import { getCanTypeOfDocumentBeSigned } from '../../../government_book/details_expedient/services/getCanTypeOfDocumentBeSigned';
import PreviewPdfModalProvider from '../../../government_book/details_expedient/context/previewPdfModalContext';
import DownloadPreviewDocumentModal from '../../../government_book/details_expedient/modals/DownloadPreviewDocumentModal';

const ElectronicSignatureProcess = ({
  onPreviousToAddFileToSign = async () => true,
  onCreatePkcs7 = () => {},
  disableSingleSignature = false,
  disableMultiSignature = false,
  isDownloadModelEnabled = false,
  el,
  fileData,
}) => {
  const {
    isElectronicSignatureModalSowing,
    setIsElectronicSignatureModalSowing,
    electronicSignaturesList,
    onCloseModal,
    onAddElectronicSignature,
    isMultipleSignature,
    setIsMultipleSignature,
    isReadyToCreatePkcs7,
    documentToSign,
    onAddDocumentToSign,
    onDelteElectronicSignatureById,
    singleElectronicSignature,
    isThereASignature,
    elementId,
  } = useElectronicSignatureProcessContext();

  useEffect(() => {
    if (disableSingleSignature) {
      setIsMultipleSignature(true);
    } else if (disableMultiSignature) {
      setIsMultipleSignature(false);
    }
  }, [disableSingleSignature, disableMultiSignature]);

  const doesMultipleSignatureToogleEnabled = !disableSingleSignature && !disableMultiSignature;

  const handleOnAddDocumentToSign = async (files) => {
    const canTypeOfDocumentBeSigned = getCanTypeOfDocumentBeSigned(files[0].type);
    if (!canTypeOfDocumentBeSigned) {
      showAlertForDocumentToBeSignedNotAllowed();
      return;
    }

    const isAValidMaxFileSize = getIsAValidMaxFileSize(files[0]);
    if (!isAValidMaxFileSize) {
      NotificationManager.error(
        'El archivo que intenta cargar al sistema, supera los 18MB de tamaño permitido. Intente con un documento de menor tamaño'
      );
      return;
    }

    const fileToSave = getFileWithExtensionInLowercase(files[0]);

    const hasPreviousActivityBeenCompleted = await onPreviousToAddFileToSign([fileToSave]);
    if (!hasPreviousActivityBeenCompleted) {
      return;
    }

    onAddDocumentToSign([fileToSave]);
  };

  return (
    <>
      <TextTooltip
        text={
          'El nombre del documento a firmar sólo debe incluir números, espacios o letras sin acentos'
        }
      >
        <SignatureInputFile
          label="* Documento a firmar"
          setFile={handleOnAddDocumentToSign}
          id={`documentToSign`}
          accept={['.pdf', '.PDF', '.doc', '.DOC', '.docx', '.DOCX']}
          fileName={documentToSign ? documentToSign.name : ''}
          isMultiFiles
          fileData={fileData}
        />
      </TextTooltip>

      <div className="d-flex mb-4">
        {isDownloadModelEnabled && (
          <div className="mt-2">
            <PreviewPdfModalProvider>
              <DownloadPreviewDocumentModal
                document={{ file_path: fileData.route }}
                documentType={el.label}
                isDownloadDocumentButtonShowing={true}
              />
            </PreviewPdfModalProvider>
          </div>
        )}

        <a
          className={fileData.status === 2 ? 'd-block mt-2 ml-2 btn btn-secondary' : 'd-none'}
          href={fileData.route}
          target="_blank"
          rel="noopener noreferrer"
          title={fileData.route}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textDecoration: 'none',
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <g fill="none">
              <path d="M24 0v24H0V0h24ZM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01l-.184-.092Z" />
              <path
                fill="currentColor"
                d="M20 14.5a1.5 1.5 0 0 1 1.5 1.5v4a2.5 2.5 0 0 1-2.5 2.5H5A2.5 2.5 0 0 1 2.5 20v-4a1.5 1.5 0 0 1 3 0v3.5h13V16a1.5 1.5 0 0 1 1.5-1.5Zm-8-13A1.5 1.5 0 0 1 13.5 3v9.036l1.682-1.682a1.5 1.5 0 0 1 2.121 2.12l-4.066 4.067a1.75 1.75 0 0 1-2.474 0l-4.066-4.066a1.5 1.5 0 0 1 2.121-2.121l1.682 1.682V3A1.5 1.5 0 0 1 12 1.5Z"
              />
            </g>
          </svg>
        </a>
      </div>

      {documentToSign && (
        <>
          {doesMultipleSignatureToogleEnabled && (
            <ToggleButton
              onChange={(event) => setIsMultipleSignature(event.target.checked)}
              name="isMultipleSignature"
              size={'medium'}
              isCheckedControlled={isMultipleSignature}
              id={`toggleButton-${elementId}`}
            >
              Habilitar multifirma
            </ToggleButton>
          )}
          <Button
            variant="success"
            onClick={() => setIsElectronicSignatureModalSowing(true)}
            className={'mb-3'}
            style={{ marginTop: '20px' }}
          >
            {isThereASignature && !isMultipleSignature ? 'Cambiar Firma' : 'Agregar Firma'}
          </Button>
        </>
      )}

      {isElectronicSignatureModalSowing && (
        <CredentialsModal
          showModalConfirmation
          isModalSowing={isElectronicSignatureModalSowing}
          onCloseModal={onCloseModal}
          addElectronicSignatureHandle={onAddElectronicSignature}
          isMultipleSignature={isMultipleSignature}
          isReadyToCreatePkcs7={isReadyToCreatePkcs7}
          onCreatePkcs7={onCreatePkcs7}
          disableSignatureButton={disableSingleSignature || disableMultiSignature}
        />
      )}
    </>
  );
};

export default ElectronicSignatureProcess;
